// extracted by mini-css-extract-plugin
export default {"login-wrap":"login-wrap--DrpaQ","title":"title--gD2ae","login-label":"login-label--dANUW","description":"description--gZ5NK","logo":"logo--pJltE"};